import {Component, Input} from "@angular/core";
import '@angular/localize/init';


@Component({
  selector: 'bn-app-state-no-data',
  templateUrl: './app-state-no-data.component.html',
  styleUrls: ['./app-state-no-data.component.scss', '../bn-app-state-widget.component.scss']
})
export class AppStateNoDataComponent {
  @Input() notResultsTitle?: string
  @Input() notResultsTitleLine2?: string
  @Input() notResultsSubTitle?: string;
  @Input() notResultsSubSubTitle?: string;

  readonly defaultTitleResultText = $localize`:@@bn-error-state-couldnt-load.app-state-no-data.no-results-found:No results found`;
  readonly defaultSubtitleResultText = $localize`:@@bn-error-state-couldnt-load.app-state-no-data.try-diffetent-criteria:We can't find what you're looking for. Please try a different criteria.`;
}
